var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCounterInteraction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.23,168.76a12.6,12.6,0,0,0-.91-21.93l-15.11-2.93q.6,28.42.82,56.86c3.86-.72,7.8-1.91,10.7-4.56s4.45-7.09,2.76-10.64a10,10,0,0,0,1.74-16.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.84,167.28l-.34-6.72,40.15-8.93c12.41-1.71,26.26,10.36,27.44,22.83,1.3,13.86,2.35,30.83,1,41.24-2.66,20.93-18.55,24.08-18.55,24.08l1.29,20.56c.51,12-9.53,15-21.55,15.51h0a21.81,21.81,0,0,1-22.69-20.11Z",
    style: {
      fill: "#966960"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,188.13a2.67,2.67,0,0,1-2.5,2.77,2.54,2.54,0,0,1-2.82-2.32,2.67,2.67,0,0,1,2.49-2.78A2.57,2.57,0,0,1,184.54,188.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,183.44c-.32.36-2.39-1.07-5.27-1s-4.93,1.6-5.26,1.26c-.16-.15.16-.79,1.06-1.49a7.38,7.38,0,0,1,4.2-1.43,7,7,0,0,1,4.2,1.21C185.8,182.66,186.12,183.28,186,183.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.78,189.87a2.67,2.67,0,0,1-2.49,2.77,2.55,2.55,0,0,1-2.83-2.32,2.67,2.67,0,0,1,2.49-2.78A2.57,2.57,0,0,1,157.78,189.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.72,184.86c-.33.36-2.4-1.08-5.27-1s-4.94,1.6-5.26,1.26c-.16-.16.16-.79,1.06-1.49a7.27,7.27,0,0,1,4.19-1.44,7.07,7.07,0,0,1,4.21,1.21C157.55,184.08,157.87,184.7,157.72,184.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.81,205.85c0-.16,1.76-.52,4.64-1,.73-.1,1.43-.27,1.53-.77a3.7,3.7,0,0,0-.55-2.16l-2.35-5.53c-3.26-7.86-5.65-14.34-5.33-14.47s3.22,6.14,6.48,14l2.26,5.56a4.27,4.27,0,0,1,.47,2.87,1.85,1.85,0,0,1-1.18,1.11,4.66,4.66,0,0,1-1.24.21C170.63,206,168.83,206,168.81,205.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.56,239.83a55.14,55.14,0,0,1-28.84-6.6s7.49,14.37,29,11.8Z",
    style: {
      fill: "#77544d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.81,212.82a5.19,5.19,0,0,0-4.7-1.78,4.73,4.73,0,0,0-3.22,1.85,3,3,0,0,0-.12,3.44,3.5,3.5,0,0,0,3.8.83,11,11,0,0,0,3.61-2.3A3.15,3.15,0,0,0,168,214a1,1,0,0,0,0-1.07",
    style: {
      fill: "#77544d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.41,208.11c.47-.05.57,3.07,3.31,5.21s6.05,1.68,6.09,2.12c.05.19-.72.63-2.13.71a7.73,7.73,0,0,1-5.07-1.6,6.77,6.77,0,0,1-2.58-4.37C159.87,208.88,160.2,208.09,160.41,208.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.11,176.72c-.26.79-3.14.51-6.5,1s-6.06,1.51-6.53.83c-.21-.33.24-1.08,1.32-1.87a11.43,11.43,0,0,1,9.92-1.41C157.58,175.75,158.22,176.34,158.11,176.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.56,173.59c-.48.67-2.48,0-4.87.09s-4.38.58-4.87-.09c-.21-.33.09-1,1-1.64a7.07,7.07,0,0,1,7.85,0C185.48,172.6,185.78,173.26,185.56,173.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.27,249.58s-21.79,23.85-21.79,51.9,17.79,63.23,16.12,83.33S104.43,431.7,99.82,445.1s-3.76,17.59-3.76,17.59H210.78l-2.31-76.8-.2-40.44.68-36.6-32.5-44v-9l-47.74-12.56Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.52,404s39.71,42.09,40.54,42.76,31.36,0,31.36,0l18.71,10.47s-1.11,3.57-7.35,1.79c0,0,1.5,2-.95,3.75H281.14l-9.53-.11H240.19L210.34,442Z",
    style: {
      fill: "#966960"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.65,281.88c-.24,14.05,3.76,28.29,12.11,39.6s21.12,19.47,35,21.35c4.68.63,9.47.58,14,1.85,4.07,1.14,7.78,3.3,11.78,4.66A31.67,31.67,0,0,0,203,350.76c1.89-.25,4-.9,4.72-2.67,1-2.63-1.9-5-4.38-6.34-30.42-16.5-62.22-36.4-87.64-59.87"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M164.18,326.54s72.47,32,82.61,32,67-51.64,67-51.64l-13.53-16.28-54.82,32.12-62.77-34.4Z",
    style: {
      fill: "#966960"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,296.68l13.32-8.32s5.84-11.46,8.92-12.8,20.55-7.76,20.55-7.76l17.7-1.63s1.59,2.26-3.33,5.59c-3.66,2.48-10.77,3.8-10.77,3.8l-4.37,2s3.29,3.7,5.91,3.6c2.34-.09,10.53-4.88,13.1-3.86s-.77,7.71-.77,7.71h0c-1.76,3.62-9.29,15.46-11.61,18.18C337.93,305,327.23,305,327.23,305l-11.52,1.42-12.88,10Z",
    style: {
      fill: "#966960"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.77,253.23s-11.18.89-18.36,12.45c-5.53,8.9-4,17.46-.33,28.9,1.61,5,5.56,10.39,9.81,14.49,9.79,9.46,30.84,22.52,30.84,22.52l32.76-37.15S156.4,258.28,137.77,253.23Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.15,259l.2.15.59.48,2.24,1.88,8.47,7.17,30,25.59.17.15-.15.18-32,36.3c-.26.3-.52.6-.77.87l-.14.16-.19-.11c-6-3.63-11.81-7.35-17.24-11.16s-10.59-7.72-14.52-12.42a49.63,49.63,0,0,1-9.33-14.52A34.36,34.36,0,0,1,117,272.4a33.8,33.8,0,0,1,2-5.53,28.29,28.29,0,0,1,5.18-7.79,25.47,25.47,0,0,1,4.53-3.8l1.33-.78c.3-.17.46-.24.46-.24l-.43.29-1.3.81a27.12,27.12,0,0,0-4.44,3.86,28.38,28.38,0,0,0-5.06,7.77,32.72,32.72,0,0,0-1.9,5.49,34.78,34.78,0,0,0-.93,6.45,35.41,35.41,0,0,0,2.52,14.62,49.36,49.36,0,0,0,9.29,14.37c3.91,4.65,9.05,8.5,14.45,12.32s11.2,7.5,17.22,11.12l-.33.06.77-.88,32-36.25,0,.32-29.87-25.73-8.38-7.27-2.2-1.94-.56-.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.45,255.73a3.89,3.89,0,0,1-.06.79c-.07.52-.2,1.27-.42,2.23a30,30,0,0,1-3,7.72l-.11.2-.19-.14a87.33,87.33,0,0,0-16.66-8.43,170.76,170.76,0,0,0-20.23-6.41c-2.63-.7-4.78-1.17-6.26-1.51l-1.71-.42a2.4,2.4,0,0,1-.58-.18,2.46,2.46,0,0,1,.6.08l1.73.32c1.49.29,3.66.7,6.31,1.35a151.74,151.74,0,0,1,20.33,6.29A81.89,81.89,0,0,1,173,266.21l-.3.06a31.45,31.45,0,0,0,3.1-7.57c.25-.94.41-1.69.52-2.2A4.48,4.48,0,0,1,176.45,255.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.82,155.58a12.94,12.94,0,0,0,4.62-13.52,14.77,14.77,0,0,0-10.36-10.14,16.33,16.33,0,0,0-3-.47,13.45,13.45,0,0,0-6.53-1.65c-.4-2.67-2.87-4.68-5.5-5.3a16.56,16.56,0,0,0-8,.56,13.59,13.59,0,0,0-21.85,1.63,11.14,11.14,0,0,0-16.25,7.36,11.06,11.06,0,0,0-7.83,4,10.83,10.83,0,0,0-1.7,2.92,10.43,10.43,0,0,0-1.85,4.18,12.52,12.52,0,0,0-5,23,11.45,11.45,0,0,0,3,18.09,14.68,14.68,0,0,0,1.48,11.42,7.06,7.06,0,0,0,3.78,3.3,2.84,2.84,0,0,0,.34.78c1.31,1.91,4.35,1,6.11-.53,4.3-3.64,6.49-9.2,7.57-14.73s1.21-11.19,2.24-16.72c0-.12,0-.25.07-.39A15.45,15.45,0,0,1,141,163a39.5,39.5,0,0,0,5.1,3.05,16.58,16.58,0,0,0,19.17-4.43,24.29,24.29,0,0,0,15.65,5.17c5.61-.16,11.12-1.38,15.31-5.11a7.65,7.65,0,0,0,2.33-3.57A2.38,2.38,0,0,0,196.82,155.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.05,194.72c-.28-.14-11.31-3.94-11.49,7.5s11.34,9.26,11.37,8.93S127.05,194.72,127.05,194.72Z",
    style: {
      fill: "#966960"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.5,206.76s-.2.14-.54.29a2,2,0,0,1-1.49,0c-1.2-.46-2.19-2.39-2.21-4.45a6.52,6.52,0,0,1,.6-2.85,2.27,2.27,0,0,1,1.52-1.5,1,1,0,0,1,1.17.56c.15.32.07.55.13.57s.25-.19.16-.66a1.29,1.29,0,0,0-.43-.73,1.56,1.56,0,0,0-1.1-.3,2.78,2.78,0,0,0-2.11,1.74,6.8,6.8,0,0,0-.74,3.17c0,2.31,1.18,4.49,2.83,5a2.13,2.13,0,0,0,1.83-.28C123.48,207,123.54,206.78,123.5,206.76Z",
    style: {
      fill: "#77544d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.81,140.2s0,.08.1.26a5.23,5.23,0,0,1,.21.82,8.74,8.74,0,0,1-2.35,7.71,9,9,0,0,1-6.06,2.64l.21-.18a19.68,19.68,0,0,1-4.58,10,15.31,15.31,0,0,1-5,3.87,12.68,12.68,0,0,1-6.56,1.07,22.3,22.3,0,0,1-6.37-1.5,17.08,17.08,0,0,1-5.33-3.1h.35a20.74,20.74,0,0,1-9.5,5.47,16.26,16.26,0,0,1-8.61-.59,16.91,16.91,0,0,1-5-2.71,13.41,13.41,0,0,1-1.14-1,2.26,2.26,0,0,1-.36-.38s.54.47,1.6,1.24a17.51,17.51,0,0,0,5,2.55,16.11,16.11,0,0,0,8.42.47,20.43,20.43,0,0,0,9.24-5.41l.17-.16.17.15a16.84,16.84,0,0,0,5.17,3,21.89,21.89,0,0,0,6.23,1.46,12.07,12.07,0,0,0,6.3-1,14.59,14.59,0,0,0,4.81-3.73,19.27,19.27,0,0,0,4.54-9.74l0-.18h.18a8.69,8.69,0,0,0,5.82-2.45,8.4,8.4,0,0,0,2.35-4.29,9,9,0,0,0,.12-3.17C200.9,140.58,200.78,140.2,200.81,140.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.13,144.48a25.43,25.43,0,0,0-1,3.93,16.37,16.37,0,0,0,1.9,10.16l.1.17-.15.12a10.53,10.53,0,0,0-3,4.67,10.08,10.08,0,0,0,0,6.08,10.57,10.57,0,0,0,4.91,6l.21.11-.1.22a13.1,13.1,0,0,0-1.29,7.14,14.25,14.25,0,0,0,1.69,5.54,16.14,16.14,0,0,0,3.27,4,1.34,1.34,0,0,1-.3-.2,9.05,9.05,0,0,1-.81-.65,12.85,12.85,0,0,1-2.43-3,14.19,14.19,0,0,1-1.84-5.64,13.48,13.48,0,0,1,1.26-7.41l.11.33a11,11,0,0,1-5.18-6.32,10.58,10.58,0,0,1,.06-6.4,10.9,10.9,0,0,1,3.18-4.86l0,.29a16.29,16.29,0,0,1-1.78-10.43,14.42,14.42,0,0,1,.8-2.92,6.53,6.53,0,0,1,.32-.73C120.08,144.55,120.12,144.47,120.13,144.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,210.76a8.74,8.74,0,0,0-.22,2.06,3,3,0,0,0,.83,1.93,2.53,2.53,0,0,0,2.35.66,2.11,2.11,0,0,0,1.42-1.89,4,4,0,0,0-.4-2.12c-.56-1.15-1.06-1.81-1-1.86a5.38,5.38,0,0,1,1.31,1.7,4.19,4.19,0,0,1,.55,2.33,3,3,0,0,1-.47,1.39,2.32,2.32,0,0,1-1.29.95,2.93,2.93,0,0,1-2.83-.83,3.26,3.26,0,0,1-.86-2.24A3.1,3.1,0,0,1,120.85,210.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.91,288.79s-.11.15-.34.39l-1,1.05L180.73,294c-3.21,3.23-7.59,7.74-12.26,12.87s-8.75,9.93-11.66,13.43l-3.44,4.15-1,1.12a2,2,0,0,1-.35.37s.08-.16.27-.43l.87-1.18c.76-1,1.89-2.48,3.31-4.27,2.84-3.56,6.88-8.39,11.56-13.54s9.11-9.62,12.39-12.78c1.64-1.58,3-2.84,3.93-3.7l1.1-1A1.79,1.79,0,0,1,185.91,288.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.52,277.86l9.13-9,10.86-1.9,38.28,14.93s6,10.56,1.36,18.32-9,7.48-9,7.48l-8.14-5.16L372,305.76s-12.22-8.42-12.49-10.05-.27-11.4-.27-11.4l-1.15-1.62A3.74,3.74,0,0,1,358.52,277.86Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.87,292.63a112.18,112.18,0,0,0,18.34,8.76,10.62,10.62,0,0,0,4.41.93,5.07,5.07,0,0,0,3.78-2.05,4.17,4.17,0,0,0,.38-4.21,7.68,7.68,0,0,0-3.28-2.83l-11.61-6.6",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.81,292.74A114.36,114.36,0,0,0,370,298.13a57.59,57.59,0,0,0,10.32,4.09c2.54.6,5.53-.1,6.62-2.73s-.7-4.77-2.93-6.09c-4-2.35-8.06-4.59-12.09-6.88a.12.12,0,0,0-.12.21L383,293.1c1.75,1,3.84,2.11,4,4.37a4.52,4.52,0,0,1-4.07,4.68c-2.14.3-4.29-.69-6.24-1.45s-4-1.61-5.94-2.5a114.32,114.32,0,0,1-10.86-5.68c-.14-.08-.26.14-.12.22Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.63,296c5,5.57,11.83,10.71,17.58,16.56a8.32,8.32,0,0,0,1.39-9.81",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.54,296.07c5.42,6,11.93,10.82,17.58,16.56a.15.15,0,0,0,.18,0,8.5,8.5,0,0,0,1.41-10c-.08-.14-.29,0-.21.13a8.3,8.3,0,0,1,.15,7.53,5.16,5.16,0,0,1-1.16,1.74c-.35.26-.31.19-.68-.11s-.49-.5-.74-.74c-1.12-1.09-2.27-2.16-3.43-3.22-4.37-4-8.95-7.73-12.93-12.11-.1-.12-.28.06-.17.18Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.37,274.39c-6.7-3.9-17.38-5.48-29.22-7.46l-11.58,21.14s20.89,3.16,29.77,7c12.7,5.51,19.56,22.12,19.56,22.12l16.76-20.76S398.35,284.45,377.37,274.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.7,280.06,373.59,284c1.35.89,2.74,1.86,2.21,3.58-.63,2.05-2.74,2.68-5.23,2l-.9,1.67-.77-.24.91-1.68a5.71,5.71,0,0,1-3-2.44l.84-.73a5.07,5.07,0,0,0,2.69,2.25l2.08-3.87c-1.29-.88-2.56-1.85-2-3.58.61-2,2.67-2.67,5.07-2.05l.91-1.67.76.24-.91,1.68a6,6,0,0,1,2.65,1.83l-.77.78A5.11,5.11,0,0,0,375.7,280.06Zm-2.63,4.87-2,3.68c1.75.45,3.13,0,3.53-1.25C374.93,286.33,374.09,285.62,373.07,284.93Zm-.13-1.4,2-3.71c-1.69-.38-3,.1-3.4,1.34C371.22,282.16,372,282.85,372.94,283.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.54,275.94l.52.23,1.51.73c.66.32,1.48.73,2.4,1.26s2,1.11,3.19,1.87a61.21,61.21,0,0,1,8.09,5.94,43.89,43.89,0,0,1,8.63,9.91l.07.12-.09.11-14,17.68-.25.32-.17-.38a49.07,49.07,0,0,0-6-10.06,35.15,35.15,0,0,0-9.15-8.38,31.62,31.62,0,0,0-7.74-3.25c-2.66-.81-5.31-1.52-7.91-2.18-5.21-1.31-10.25-2.46-15-3.47l-.33-.07.17-.28c3.6-6.22,6.89-11.89,9.78-16.87l.07-.12.13,0c8.24,1.37,14.92,2.62,19.42,4a33.19,33.19,0,0,1,5.05,1.94,14,14,0,0,1,1.66.91,2.43,2.43,0,0,1-.44-.2c-.28-.14-.7-.37-1.27-.61a36.23,36.23,0,0,0-5.07-1.83,173.42,173.42,0,0,0-19.42-3.84l.21-.1-9.71,16.92-.16-.36c4.78,1,9.82,2.14,15,3.45,2.61.66,5.27,1.36,7.94,2.18a31.49,31.49,0,0,1,7.86,3.3,35.22,35.22,0,0,1,9.28,8.51,48.5,48.5,0,0,1,6.08,10.18l-.42-.06,14.07-17.63,0,.23a44.19,44.19,0,0,0-8.48-9.86,63.08,63.08,0,0,0-8-6c-1.15-.77-2.22-1.37-3.14-1.91s-1.72-1-2.38-1.31l-1.48-.78C376.7,276.05,376.54,275.94,376.54,275.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.32,272.41c-.22.17-22.25,7.09-22.25,7.09l-7.26,3.09s3.09,4.91,7.9,3.91,6.17-2,6.17-2l7.72.36s3.23,13.64,27.56,7.1",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.16,292a2.63,2.63,0,0,1-.58.18l-1.7.43a42.12,42.12,0,0,1-6.43,1.15,31,31,0,0,1-4.6.13l-1.28,0-1.31-.2-1.35-.2-1.37-.37a18.19,18.19,0,0,1-2.76-1,16.43,16.43,0,0,1-2.62-1.69,11.2,11.2,0,0,1-3.8-5.4l.23.19-7.72-.35.16-.05a15.55,15.55,0,0,1-3.83,1.46,23.9,23.9,0,0,1-3,.66,6.38,6.38,0,0,1-3.07-.38,9.88,9.88,0,0,1-4.52-3.72l-.16-.25.28-.12,7.27-3.07h0l16.14-5,4.55-1.39,1.21-.37a2.1,2.1,0,0,1,.42-.11,1.72,1.72,0,0,1-.4.18l-1.18.43-4.52,1.52-16.08,5.19h0l-7.26,3.1.12-.36a9.46,9.46,0,0,0,4.27,3.51,6.15,6.15,0,0,0,2.83.35,25.26,25.26,0,0,0,2.95-.65,15.54,15.54,0,0,0,3.66-1.38l.09-.05h.07l7.72.37h.18l0,.19a10.53,10.53,0,0,0,1.45,2.88,12.59,12.59,0,0,0,2.17,2.26A15,15,0,0,0,385,291.6a17,17,0,0,0,2.69,1L389,293l1.32.21,1.29.21,1.26.06a33.82,33.82,0,0,0,4.55-.07,50.17,50.17,0,0,0,6.43-1l1.71-.36A4.16,4.16,0,0,1,406.16,292Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.69,272.55c0,.87-1,1.58-2.14,1.58s-2.15-.71-2.15-1.58,1-1.59,2.15-1.59S354.69,271.67,354.69,272.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.79,308.07c0,1.14.68,2.07,1.52,2.07s1.53-.93,1.53-2.07-.69-2.06-1.53-2.06S385.79,306.94,385.79,308.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "649.85 407.38 646.55 408.23 511.62 412.02 507.21 462.58 652.6 462.8 655.35 459.23 649.85 407.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.78,215.8l16.67-7.64,7.82-9.91,51.45-6.86,7.21,9.37,40.15,26.15S661.69,371,660,383.69s-10.15,23.69-10.15,23.69-87.34,23.27-118.13,11.43c0,0-20.89-13-18.78-34.19s13.4-79.69,13.4-79.69Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.39,277.9l70.74,19.71s-.42-7.81,6.24-9.31c0,0,41.58-58.88,46.15-63.87s13.26-8.63,13.26-8.63l-29.84,118s-25.9,13.76-36.47,11.68-38-11.64-54.23-22.87L405.3,307.08Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.18,323.63a4.38,4.38,0,0,1-.26-1.09c-.16-.81-.36-1.8-.59-3a75.15,75.15,0,0,0-2.6-9.6,54.25,54.25,0,0,0-2.1-5.05,40,40,0,0,0-2.17-3.9c-1.36-2.15-2.4-3.34-2.33-3.41a4.68,4.68,0,0,1,.78.8,11.47,11.47,0,0,1,.84,1c.31.4.67.86,1,1.4a34,34,0,0,1,2.29,3.89,46.1,46.1,0,0,1,2.16,5.09,58.79,58.79,0,0,1,2.47,9.71c.21,1.26.36,2.29.43,3A4.53,4.53,0,0,1,495.18,323.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.55,225.67S641,222.55,629.2,249s-12.67,100.64-12.67,100.64c-1.4-2.75-26.55,18.05-31.51,22.92l-51.4,14.23,9,33s63.23-6.47,79.77-14.69c18.74-9.3,32.23-12.18,37.62-22.46s18.66-72.1,20.12-92.11S687.11,230.72,671.55,225.67Z",
    style: {
      fill: "#F2A413"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.44,214.14a1.85,1.85,0,0,1-.22.4c-.16.25-.39.63-.71,1.1-.63,1-1.58,2.3-2.8,4-2.4,3.32-6,7.78-9.6,13l-.25.36-.2-.39c-.33-.64-.67-1.32-1-2-3.15-6.16-6-11.76-8-15.82-1-2-1.77-3.61-2.37-4.82l-.62-1.33a2.18,2.18,0,0,1-.19-.47s.12.14.28.43.43.76.71,1.28l2.52,4.74c2.11,4,5,9.59,8.14,15.75l1,2-.44,0c3.65-5.29,7.27-9.7,9.75-13l2.92-3.85A12.83,12.83,0,0,1,593.44,214.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.76,202.7a3.59,3.59,0,0,1-.45.45l-1.35,1.2c-1.16,1.06-2.86,2.57-4.9,4.52a175.86,175.86,0,0,0-14.94,16.07c-2.33,2.86-4.48,5.68-6.37,8.3l-.25.35-.17-.39-6-13.54-1.7-3.92c-.18-.42-.32-.77-.43-1.05a1.59,1.59,0,0,1-.13-.37,1.46,1.46,0,0,1,.2.34c.14.27.3.61.51,1,.45,1,1.06,2.26,1.82,3.86L603.78,233l-.43-.05c1.88-2.64,4-5.47,6.37-8.34a156.31,156.31,0,0,1,15.09-16c2.07-1.92,3.81-3.39,5-4.4l1.42-1.14A2.37,2.37,0,0,1,631.76,202.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.22,379.75s-.08.2-.25.59l-.78,1.71a39,39,0,0,1-3.83,6.19,40.24,40.24,0,0,1-8.27,8.16,55.26,55.26,0,0,1-13.72,7.3,106.8,106.8,0,0,1-18.45,4.84c-3.39.65-6.94,1.17-10.55,1.95s-7.35,1.61-11.23,2.27c-15.52,2.59-32.89,4.89-51.51,7.25l-.21,0-.06-.21c-2.89-10.6-5.9-21.64-9-33l-.07-.27.27-.05c3.26-.62,6.74-1.37,10.23-2.2,7.27-1.72,14.35-3.72,21.32-5.62s13.92-3.44,20.08-6.53a40.72,40.72,0,0,0,8.36-5.7c2.53-2.19,4.87-4.53,7.23-6.77a65.86,65.86,0,0,1,7.34-6.22,26.73,26.73,0,0,1,8.34-4.08l-.17.19c3.88-27.4,7.12-50.33,9.4-66.44,1.16-8,2.06-14.36,2.69-18.7.31-2.14.55-3.8.72-4.93.09-.55.15-1,.2-1.26s.07-.43.07-.43a3.4,3.4,0,0,1,0,.43c0,.3-.09.72-.16,1.27-.15,1.14-.37,2.79-.65,4.94-.6,4.34-1.46,10.68-2.56,18.72-2.23,16.11-5.41,39.06-9.21,66.46l0,.15-.15,0a26.46,26.46,0,0,0-8.19,4,65.48,65.48,0,0,0-7.27,6.19c-2.36,2.24-4.7,4.59-7.25,6.79a41.13,41.13,0,0,1-8.45,5.78c-6.24,3.13-13.24,4.63-20.17,6.58s-14.06,3.91-21.34,5.63c-3.5.83-7,1.58-10.25,2.2l.2-.32c3.09,11.34,6.09,22.39,9,33l-.28-.18c18.61-2.34,36-4.62,51.5-7.18,15.31-3.41,29.36-4.72,40.19-8.93a55.07,55.07,0,0,0,13.68-7.2A40.41,40.41,0,0,0,660.11,382c.35-.74.63-1.3.81-1.69S661.22,379.75,661.22,379.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M651.08,361.34a8,8,0,0,0-1.6-3.65c-3.72-5.23-10.08-8.1-16.44-8.95s-9.95-.35-16.29.69l-.4.29c10.72-.82,18.53,3.38,25.59,11.58a16,16,0,0,0,3.28,3.3,4.14,4.14,0,0,0,4.4.29A3.79,3.79,0,0,0,651.08,361.34Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M646.55,357.19a33.16,33.16,0,0,0-3.38-3.43A23.27,23.27,0,0,0,632.73,349a35.64,35.64,0,0,0-11.58-.15c-1.48.19-2.67.38-3.5.51a6.19,6.19,0,0,1-1.3.14,6.12,6.12,0,0,1,1.26-.34c.82-.19,2-.43,3.49-.68a33.63,33.63,0,0,1,11.73,0,22.49,22.49,0,0,1,10.57,5,16.8,16.8,0,0,1,2.44,2.61A5.6,5.6,0,0,1,646.55,357.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.07,226.81a41.41,41.41,0,0,0-6.72-1,27,27,0,0,0-3.43.09c-.61.07-1.24.2-1.88.29a13.1,13.1,0,0,0-2,.45,25,25,0,0,0-8.12,3.76,32.59,32.59,0,0,0-6.54,6.17c-.45.52-.8,1.11-1.2,1.63s-.78,1-1.08,1.58c-.61,1.07-1.25,2-1.72,3s-.87,1.79-1.24,2.55-.59,1.45-.82,2-.38.91-.52,1.26-.2.43-.22.42a1.4,1.4,0,0,1,.12-.46c.12-.35.26-.78.43-1.29s.42-1.25.74-2l1.19-2.61c.45-1,1.07-1.94,1.67-3,.3-.55.71-1,1.08-1.61s.74-1.13,1.2-1.67a31.46,31.46,0,0,1,6.62-6.29,25,25,0,0,1,8.29-3.81,13.49,13.49,0,0,1,2-.43c.66-.09,1.3-.21,1.92-.27a27.19,27.19,0,0,1,3.48,0l1.52.11c.47.07.91.15,1.33.23a12.2,12.2,0,0,1,2.11.47l1.31.4A2.32,2.32,0,0,1,666.07,226.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.43,256.57a1,1,0,0,1,0,.28c0,.21,0,.48,0,.82,0,.75-.13,1.8-.24,3.14-.21,2.72-.57,6.66-1,11.53-1,9.73-2.53,23.15-4.71,37.92s-4.56,28.07-6.45,37.66c-.94,4.8-1.73,8.68-2.32,11.35-.29,1.3-.51,2.33-.68,3.07-.07.33-.14.59-.19.8a.91.91,0,0,1-.08.27,1,1,0,0,1,0-.28c0-.21.08-.48.14-.81.14-.74.34-1.78.58-3.09.52-2.73,1.26-6.6,2.16-11.38,1.79-9.61,4.11-22.91,6.3-37.67s3.79-28.16,4.85-37.88c.51-4.83.93-8.76,1.22-11.51.15-1.33.26-2.38.34-3.13,0-.34.07-.6.1-.82A.84.84,0,0,1,531.43,256.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M520.94,333.75c3.36-12.49,4.67-26.3,6.39-39.48-2.13,14.93-9.4,32.28-17.72,44.86C513.75,337.31,517.61,335.51,520.94,333.75Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M595.5,215.36c1.75,7.52,3.33,15.26,6,22.53a4.63,4.63,0,0,0,1.3,2.18,3,3,0,0,0,2.79.29,6.8,6.8,0,0,0,2.36-1.66c3.64-3.62,5.61-8.52,7.9-13.11,3.85-7.73,12.42-19.62,14.22-21.43-10.74,9-18.68,19.27-26.46,29.24Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M568.49,209.93a198.39,198.39,0,0,0,9.87,29.47c.19.45.47,1,.95,1s.84-.36,1.12-.74c4.81-6.49,9.72-16.89,12.18-24.33l-12.72,17.15Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M601.15,320a2.12,2.12,0,0,1-.54.26l-1.59.66c-1.38.57-3.39,1.35-5.89,2.28-5,1.86-12,4.26-19.8,6.56s-15,4.06-20.19,5.2c-2.61.58-4.72,1-6.19,1.28l-1.69.3a3.34,3.34,0,0,1-.6.08,2.4,2.4,0,0,1,.58-.18l1.67-.4,6.14-1.44c5.19-1.23,12.33-3.05,20.14-5.34S588,324.59,593,322.82l6-2.12,1.62-.56A2.21,2.21,0,0,1,601.15,320Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.64,257.53s-.07.07-.23.17l-.69.44c-.62.38-1.52,1-2.66,1.73-2.29,1.52-5.46,3.93-9.57,6.67a47.94,47.94,0,0,1-7.06,3.92,27.48,27.48,0,0,1-9,2.23,18.21,18.21,0,0,1-10-2,12.54,12.54,0,0,1-4.1-3.62,8.78,8.78,0,0,1-1.71-5.37,6,6,0,0,1,.84-2.77,5.77,5.77,0,0,1,2.08-2,7.78,7.78,0,0,1,5.41-.81,6.75,6.75,0,0,1,4.37,2.94,8.59,8.59,0,0,1,1.38,4.87,10.28,10.28,0,0,1-1.15,4.68,10.48,10.48,0,0,1-2.94,3.47,14.62,14.62,0,0,1-7.55,2.81,19.41,19.41,0,0,1-6.65-.59,31.11,31.11,0,0,1-4.75-1.64c-1.27-.55-2.23-1-2.87-1.37l-.72-.39q-.25-.13-.24-.15a.84.84,0,0,1,.26.1l.75.35c.66.3,1.62.75,2.9,1.27a33,33,0,0,0,4.74,1.55,19.73,19.73,0,0,0,6.54.51,14.38,14.38,0,0,0,7.33-2.79,10,10,0,0,0,2.79-3.34,9.9,9.9,0,0,0,1.08-4.47,8.11,8.11,0,0,0-1.31-4.6,6.28,6.28,0,0,0-4.07-2.71,7.22,7.22,0,0,0-5,.76,5.07,5.07,0,0,0-1.89,1.79,5.47,5.47,0,0,0-.77,2.53,8.22,8.22,0,0,0,1.62,5,12,12,0,0,0,3.93,3.48,17.72,17.72,0,0,0,9.72,2,27.11,27.11,0,0,0,8.87-2.15,47.16,47.16,0,0,0,7-3.83c4.12-2.68,7.33-5.06,9.66-6.53,1.16-.74,2.08-1.3,2.71-1.65l.73-.4A.92.92,0,0,1,587.64,257.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.1,284.27s-.08,0-.22-.12l-.61-.42a18.93,18.93,0,0,0-2.44-1.4,19.86,19.86,0,0,0-10-2A19.46,19.46,0,0,0,598.5,287a15.71,15.71,0,0,0-3.92,7.93,8.51,8.51,0,0,0,.56,4.59,6.48,6.48,0,0,0,3.17,3.43A6.07,6.07,0,0,0,603,303a7.66,7.66,0,0,0,3.67-2.77,5.92,5.92,0,0,0,1-2,7.21,7.21,0,0,0,.28-2.21,9.13,9.13,0,0,0-1.09-4.16,10.51,10.51,0,0,0-2.59-3.22,11.86,11.86,0,0,0-3.41-1.9,15.65,15.65,0,0,0-7-.73,26.85,26.85,0,0,0-9.7,3.42c-1.07.59-1.89,1.08-2.44,1.42l-.64.37-.22.12s.06-.07.19-.16l.61-.42c.54-.36,1.34-.88,2.4-1.51a36.1,36.1,0,0,1,4-2,21.9,21.9,0,0,1,5.75-1.58,15.85,15.85,0,0,1,7.18.68,12.24,12.24,0,0,1,3.56,2,10.86,10.86,0,0,1,2.72,3.34,9.64,9.64,0,0,1,1.17,4.39,7.89,7.89,0,0,1-.29,2.35,6.58,6.58,0,0,1-1,2.19,8.17,8.17,0,0,1-3.91,3,6.65,6.65,0,0,1-5-.13,7,7,0,0,1-3.42-3.7,9.09,9.09,0,0,1-.6-4.87,16.24,16.24,0,0,1,4.07-8.18,19.55,19.55,0,0,1,23.78-4.51A14,14,0,0,1,625.1,284.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.41,260.06l-.23.09-.69.21a21.93,21.93,0,0,1-2.69.58,26.12,26.12,0,0,1-10.1-.48,25.53,25.53,0,0,1-6.52-2.61,15.8,15.8,0,0,1-3.18-2.33,9.48,9.48,0,0,1-2.35-3.48,6.67,6.67,0,0,1,0-4.41,5,5,0,0,1,3.18-3.3,5.12,5.12,0,0,1,4.62,1.06,6.61,6.61,0,0,1,2.44,4.25,9.64,9.64,0,0,1-.68,4.86,17,17,0,0,1-2.36,4.11,23.89,23.89,0,0,1-14.12,8.92,22.84,22.84,0,0,1-7,.35,23.83,23.83,0,0,1-9.61-3.14,17.47,17.47,0,0,1-3-2.18l.21.13.58.41a25.11,25.11,0,0,0,2.32,1.47,24.23,24.23,0,0,0,9.54,2.94,22.72,22.72,0,0,0,6.88-.4,23.58,23.58,0,0,0,13.8-8.81,16.24,16.24,0,0,0,2.29-4,9.25,9.25,0,0,0,.65-4.6,6.09,6.09,0,0,0-2.26-3.91,4.56,4.56,0,0,0-4.14-1,4.49,4.49,0,0,0-2.86,3,6.17,6.17,0,0,0,0,4.09,11.55,11.55,0,0,0,5.29,5.6,25.45,25.45,0,0,0,6.4,2.62,26.52,26.52,0,0,0,10,.64c1.18-.16,2.09-.34,2.7-.48l.69-.16A1.07,1.07,0,0,1,682.41,260.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.51,285.6a20.24,20.24,0,0,0-1.41-1.91,11.6,11.6,0,0,0-5.31-3.48,11.26,11.26,0,0,0-9.13,1.18,7.4,7.4,0,0,0-3.5,4.09,3,3,0,0,0,.52,2.63,4,4,0,0,0,2.53,1.31,4.41,4.41,0,0,0,2.84-.5,5.64,5.64,0,0,0,2-2,10.61,10.61,0,0,0,1.29-5.36,17.65,17.65,0,0,0-2.55-9.08,18.59,18.59,0,0,0-4.22-4.85c-1.21-.94-2-1.34-1.94-1.39a2.64,2.64,0,0,1,.56.27,17.31,17.31,0,0,1,1.5,1,17.94,17.94,0,0,1,7.13,14.09,11,11,0,0,1-1.33,5.62,6.18,6.18,0,0,1-2.17,2.23,4.93,4.93,0,0,1-3.17.57,4.48,4.48,0,0,1-2.86-1.51,3.45,3.45,0,0,1-.61-3.07,7.84,7.84,0,0,1,3.74-4.38,11.6,11.6,0,0,1,9.49-1.12,11.48,11.48,0,0,1,5.36,3.7,11.34,11.34,0,0,1,1,1.47A2.54,2.54,0,0,1,526.51,285.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.46,210.11a25.29,25.29,0,0,0-5.63,1.87,24.59,24.59,0,0,0-4.73,3.59,10.52,10.52,0,0,1,4.48-4A10.64,10.64,0,0,1,582.46,210.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.08,218a5.62,5.62,0,0,1-2.15-.71,11.9,11.9,0,0,1-6.3-8.61,5.64,5.64,0,0,1,0-2.27c.1,0,.1.86.39,2.2A13,13,0,0,0,613.1,217C614.29,217.69,615.11,218,615.08,218Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551,359a8,8,0,0,1-1.34.47,14.55,14.55,0,0,1-1.6.44c-.64.14-1.35.33-2.16.44a36.79,36.79,0,0,1-5.72.51,37.71,37.71,0,0,1-13.78-2.51,36.38,36.38,0,0,1-5.17-2.49c-.72-.39-1.32-.82-1.86-1.17a15.27,15.27,0,0,1-1.35-1,8.09,8.09,0,0,1-1.09-.92c.07-.08,1.65,1.18,4.48,2.74a39.83,39.83,0,0,0,5.16,2.36,42.23,42.23,0,0,0,6.7,1.84,43.22,43.22,0,0,0,6.91.64,40.11,40.11,0,0,0,5.66-.39C549,359.55,551,358.93,551,359Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.81,337.32a.86.86,0,0,1-.25-.08l-.7-.28-1.12-.46c-.45-.17-1-.33-1.58-.53a32.62,32.62,0,0,0-10.41-1.53,33.35,33.35,0,0,0-15,3.86,29.79,29.79,0,0,0-7.34,5.51,12,12,0,0,0-2.6,4,6.6,6.6,0,0,0,0,4.77,4.53,4.53,0,0,0,3.47,3,4.92,4.92,0,0,0,4.17-1.68,5.77,5.77,0,0,0,1.64-4.13,8.08,8.08,0,0,0-1.34-4.15,13.22,13.22,0,0,0-6.38-5.06,17.11,17.11,0,0,0-7.1-1.1,17.45,17.45,0,0,0-9.73,3.6,24.12,24.12,0,0,0-2.77,2.7.82.82,0,0,1,.14-.21l.46-.6a6.73,6.73,0,0,1,.81-.92,11.77,11.77,0,0,1,1.23-1.13,17.65,17.65,0,0,1,17.12-2.74,13.62,13.62,0,0,1,6.63,5.2,8.68,8.68,0,0,1,1.43,4.4,6.28,6.28,0,0,1-1.77,4.49,5.43,5.43,0,0,1-4.61,1.85,5,5,0,0,1-3.88-3.3,7,7,0,0,1,0-5.13,12.33,12.33,0,0,1,2.7-4.19,30,30,0,0,1,7.49-5.59,33.22,33.22,0,0,1,15.24-3.8,31.68,31.68,0,0,1,10.49,1.69c.59.22,1.12.4,1.56.58l1.12.52.67.32A1,1,0,0,1,614.81,337.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.1,325.68s-.13.11-.4.27l-1.2.69c-.52.29-1.17.64-1.94,1s-1.63.8-2.63,1.19-2.08.86-3.28,1.26-2.48.8-3.84,1.21a64.34,64.34,0,0,1-9,1.74,63.63,63.63,0,0,1-9.22.3c-1.42-.09-2.76-.15-4-.32s-2.42-.32-3.48-.51-2-.4-2.83-.58-1.54-.37-2.11-.55l-1.32-.4a1.48,1.48,0,0,1-.45-.17,1.7,1.7,0,0,1,.48.07l1.34.31c.58.14,1.29.31,2.12.46s1.78.37,2.84.5,2.2.33,3.45.44,2.58.2,4,.27a67.33,67.33,0,0,0,9.14-.34,68.54,68.54,0,0,0,9-1.69c1.35-.38,2.65-.72,3.82-1.15s2.29-.8,3.28-1.19,1.87-.78,2.65-1.12,1.43-.65,2-.92l1.24-.59A2.07,2.07,0,0,1,665.1,325.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460,336.59a1.32,1.32,0,0,1,.14-.45l.51-1.24q.35-.79.78-1.95c.3-.77.64-1.64,1-2.62.71-1.94,1.41-4.31,2.12-6.94a86.24,86.24,0,0,0,1.73-8.72,70.75,70.75,0,0,0,.64-8.85,49.67,49.67,0,0,0-.53-7.22c-.08-.51-.13-1-.22-1.46s-.19-.88-.28-1.28a18.19,18.19,0,0,0-.5-2.05l-.36-1.28a1.33,1.33,0,0,1-.09-.46s.08.14.19.43l.45,1.26a15.64,15.64,0,0,1,.59,2c.1.41.21.83.32,1.29s.17.94.27,1.46a45.39,45.39,0,0,1,.64,7.28,66.13,66.13,0,0,1-.6,8.92,80.2,80.2,0,0,1-1.78,8.77c-.74,2.64-1.48,5-2.24,6.95-.36,1-.72,1.84-1.05,2.6s-.61,1.41-.87,1.93l-.59,1.19A2,2,0,0,1,460,336.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595,214.32a1.69,1.69,0,0,1,0,.3c0,.23-.06.52-.1.89l-.42,3.4c-.36,3-1,7.23-1.74,12.5-1.56,10.54-4,25.06-7.26,41s-6.58,30.28-9.06,40.64c-1.25,5.14-2.27,9.32-3,12.25-.36,1.42-.64,2.53-.85,3.33-.09.35-.17.64-.23.86a1,1,0,0,1-.1.29,2.8,2.8,0,0,1,.05-.31q.07-.33.18-.87l.75-3.35c.68-2.93,1.65-7.12,2.84-12.29,2.38-10.38,5.65-24.73,8.9-40.65s5.75-30.43,7.41-41c.83-5.26,1.47-9.52,1.9-12.46.22-1.45.39-2.58.52-3.4.06-.36.11-.65.14-.88A1.48,1.48,0,0,1,595,214.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.94,330.44s-.12.15-.4.41l-1.2,1.11a24,24,0,0,0-1.87,1.78l-1.11,1.17a16.17,16.17,0,0,0-1.2,1.35,40.22,40.22,0,0,0-2.51,3.29c-.42.62-.86,1.24-1.29,1.91l-1.22,2.12A49.29,49.29,0,0,0,555,353.63a65.11,65.11,0,0,0-2,10.69c-.11,1.67-.28,3.26-.29,4.75,0,.75,0,1.47-.05,2.16s0,1.36,0,2c0,1.27.08,2.42.14,3.42s.11,1.88.19,2.58l.13,1.64a2.47,2.47,0,0,1,0,.57,2,2,0,0,1-.11-.56c-.07-.43-.14-1-.24-1.62s-.2-1.58-.27-2.59-.2-2.15-.22-3.43c0-.64-.05-1.3-.07-2s0-1.42,0-2.17c0-1.5.14-3.1.24-4.78a63.29,63.29,0,0,1,2-10.8,48.22,48.22,0,0,1,4.2-10.13l1.25-2.14c.44-.66.9-1.29,1.33-1.91a38.36,38.36,0,0,1,2.58-3.28,16.23,16.23,0,0,1,1.24-1.34l1.15-1.14a19.57,19.57,0,0,1,1.94-1.74l1.27-1A2,2,0,0,1,569.94,330.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.16,129.81c.62-20.9-13.83-38.46-34.75-38.5l-1.93.11a37.4,37.4,0,0,0-35.29,36.43c-.43,18.13-.68,38.15,0,47.83,1.38,20,21.6,22,21.6,22l.12,3.07,19.58,12.67,32.13-21.78Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.14,141.48a2.86,2.86,0,0,0,2.92,2.73,2.73,2.73,0,0,0,2.8-2.74,2.87,2.87,0,0,0-2.92-2.74A2.74,2.74,0,0,0,558.14,141.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.7,136.38c.37.36,2.45-1.37,5.53-1.54s5.42,1.25,5.74.85c.15-.17-.25-.83-1.27-1.49a7.83,7.83,0,0,0-4.62-1.14,7.6,7.6,0,0,0-4.38,1.69C557.79,135.53,557.51,136.22,557.7,136.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.15,140.41a2.87,2.87,0,0,0,2.92,2.73,2.73,2.73,0,0,0,2.8-2.75,2.87,2.87,0,0,0-2.92-2.73A2.73,2.73,0,0,0,588.15,140.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.33,133.78c.34.4,2.59-1.1,5.67-.93s5.26,1.83,5.61,1.47c.17-.16-.15-.85-1.1-1.62a7.88,7.88,0,0,0-4.47-1.63,7.55,7.55,0,0,0-4.53,1.2C588.53,133,588.17,133.61,588.33,133.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.47,159.75c0-.17-1.93-.4-5.05-.62-.79,0-1.55-.15-1.71-.68a4,4,0,0,1,.39-2.36q1-2.91,2-6.12c2.75-8.71,4.69-15.85,4.34-15.95s-2.87,6.86-5.61,15.57l-1.89,6.14a4.54,4.54,0,0,0-.23,3.11,2,2,0,0,0,1.35,1.08,5.13,5.13,0,0,0,1.35.11C576.53,160,578.47,159.93,578.47,159.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.65,161.37c-.5,0-.32,3.34-3,5.88s-6.3,2.36-6.3,2.83c0,.21.83.61,2.34.56a8.33,8.33,0,0,0,5.27-2.18,7.27,7.27,0,0,0,2.34-4.91C588.3,162.14,587.88,161.34,587.65,161.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.14,123.62c.28.85,3.37.54,7,1.07s6.5,1.61,7,.87c.22-.36-.27-1.16-1.42-2a12.27,12.27,0,0,0-10.65-1.48C588.7,122.58,588,123.22,588.14,123.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.68,128.44c.59.67,2.67-.18,5.21-.35s4.74.2,5.2-.56c.2-.37-.18-1-1.16-1.66a7.25,7.25,0,0,0-4.31-.9,7.17,7.17,0,0,0-4.08,1.64C558.68,127.38,558.43,128.11,558.68,128.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.31,99.24c1-.55,5.23,3.85,6.05,4.58,4.82,4.27,6.82,12.29,7.44,18.7a69,69,0,0,1-.14,18.38c-.12.78-.57,4.1-.57,4.1-.85.76-1.72,7.91-2.86,8-1.61.13-3.16-10.8-3.47-11.63a48,48,0,0,0-1.34-7.37,67,67,0,0,1-2.3-11.86c-.28-5.57-2.39-13.83-2.68-19.4C612.39,101.68,611.4,99.76,612.31,99.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.84,106.62,624.47,115a46.21,46.21,0,0,1,1.23,6.51l-11.56-7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.1,144.72c.33-.16,13.54-4.85,13.87,8.88s-13.51,11.23-13.54,10.83S622.1,144.72,622.1,144.72Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.49,159.13c.06,0,.25.16.65.34a2.38,2.38,0,0,0,1.79,0c1.44-.57,2.6-2.9,2.61-5.37a8.1,8.1,0,0,0-.75-3.41,2.77,2.77,0,0,0-1.85-1.79,1.21,1.21,0,0,0-1.39.69c-.18.39-.08.66-.15.69s-.3-.23-.21-.8a1.56,1.56,0,0,1,.52-.87,1.78,1.78,0,0,1,1.31-.38,3.36,3.36,0,0,1,2.55,2.07,8.06,8.06,0,0,1,.93,3.8c0,2.77-1.38,5.39-3.35,6a2.51,2.51,0,0,1-2.19-.31C626.52,159.46,626.44,159.16,626.49,159.13Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.52,197.67s13.15.32,26.56-9.21c0,0-5.59,14.66-22,15-.27,0-4.19-2.71-4.19-2.71Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.27,145.08c.16.18-1.91,1.78-5,1.95s-5.35-1.13-5.2-1.33,2.32.57,5.14.38S569.13,144.83,569.27,145.08Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.53,134.54c-.11.08-.51-.36-1.3-.82a7.81,7.81,0,0,0-3.34-1,21,21,0,0,0-3.64.16c-1,.09-1.55.11-1.58,0s.52-.38,1.46-.65a11.5,11.5,0,0,1,3.83-.44,6.44,6.44,0,0,1,3.67,1.41C569.41,133.85,569.63,134.48,569.53,134.54Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.25,133.43c.18.17-1,1.49-3,2.1s-3.67.18-3.62-.06,1.58-.29,3.34-.85S608.07,133.22,608.25,133.43Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.24,137.62c.14.21-1.2,1.13-3.09,1s-3.09-1.24-2.92-1.43,1.38.38,3,.48S609.12,137.37,609.24,137.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.19,132.54c-.16.24-2.34-1.68-5.64-1.83s-5.67,1.5-5.8,1.25c-.07-.09.4-.65,1.43-1.22a8.5,8.5,0,0,1,8.72.45C599.86,131.86,600.27,132.46,600.19,132.54Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.65,143.21c.18.18-1.22,1.61-3.54,2.14s-4.21-.12-4.13-.35,1.83-.08,3.91-.58S597.48,143,597.65,143.21Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.22,161.55c-.23.15-.94-.54-2.06-.74s-2,.13-2.2-.09.84-1.15,2.38-.84S590.47,161.45,590.22,161.55Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.64,160.63c-.24.12-.8-.5-1.65-1s-1.67-.65-1.69-.92,1-.55,2.16.09S592.88,160.54,592.64,160.63Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.37,180.37s.3.16.37.72a5.49,5.49,0,0,1-.47,2.06,1.49,1.49,0,0,0,.79,2.09,5,5,0,0,1,1.58,1.16,2.49,2.49,0,0,1,.28,2.27c-.48,1.46-1.57,2.29-2,3.22a2.68,2.68,0,0,0,.21,2.55c.86,1.39,1.75,2.1,1.63,2.22s-1.07-.4-2.2-1.86a3.3,3.3,0,0,1-.44-3.26c.49-1.2,1.53-2,1.85-3.16a1.59,1.59,0,0,0-.12-1.43,4.87,4.87,0,0,0-1.29-1,2.37,2.37,0,0,1-1.2-1.47,2.68,2.68,0,0,1,.24-1.6,8.07,8.07,0,0,0,.73-1.84C612.43,180.66,612.3,180.41,612.37,180.37Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.89,193.9c-.08.06-.8-.53-1.58-1.89a4.25,4.25,0,0,1-.5-2.78c.18-1.18,1.34-2,1.17-2.73s-1.15-1.29-2-1.95a2.85,2.85,0,0,1-1-2.69,2.77,2.77,0,0,1,.89-1.68c.36-.28.61-.33.64-.28a3.93,3.93,0,0,0-.86,2,2.22,2.22,0,0,0,.89,1.94c.34.27.8.5,1.27.85a2.64,2.64,0,0,1,1.1,1.64,2.6,2.6,0,0,1-.63,1.85,3.28,3.28,0,0,0-.63,1.21,3.86,3.86,0,0,0,.25,2.31C620.47,193,621,193.82,620.89,193.9Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591,112.78c.07.07-1,1-3.1,1.14s-4.87-.46-7.68.2c-1.4.37-2.69,1.06-4,1.52a7.63,7.63,0,0,1-3.61.57,4.08,4.08,0,0,1-2.3-.93c-.44-.41-.56-.72-.51-.75a5.37,5.37,0,0,0,2.86,1,7.9,7.9,0,0,0,3.24-.71,31.05,31.05,0,0,1,4-1.63,13,13,0,0,1,4.43-.2c1.32.12,2.49.25,3.46.25A19.06,19.06,0,0,0,591,112.78Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.45,109.91c0,.27-3.49.44-7.77.64s-7.77.36-7.8.09,3.43-.84,7.75-1S586.45,109.65,586.45,109.91Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.61,106.66c-.08.26-1.4.08-3,0s-3-.18-3-.44,1.33-.66,3.06-.51S583.69,106.42,583.61,106.66Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.37,138.88c.13.23-.91.84-2.19.38s-1.71-1.59-1.46-1.69.84.47,1.78.79S557.28,138.63,557.37,138.88Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.16,140.44c.1.25-.39.68-.81,1.28s-.68,1.19-1,1.17-.43-.88.18-1.72S556.08,140.2,556.16,140.44Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.76,387.82l-24.48-6.28a4.08,4.08,0,0,0-5,2.94l-6.94,27.07a4.07,4.07,0,0,0,2.93,5l51.6,13.23a4.08,4.08,0,0,0,5-2.94l6.94-27.06a4.08,4.08,0,0,0-2.94-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,424.24c-.14,0,1.78-7.07,4.28-15.7s4.65-15.61,4.79-15.57-1.78,7.08-4.29,15.71S490.13,424.28,490,424.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.52,391.24s-7.63.68-9.76.12-15.67-5.19-18.35-5.61a13.86,13.86,0,0,0-2-.17,13.41,13.41,0,0,0-6,1.3l-5.78,2.69,12.48,3.2s-.05,1.12-2.12,3.13-26.21,11.83-27.84,12.68-3.3,2-2.09,3.79,4.54,2.91,5.71,3,4.56-1,4.56-1-7,3.79-7.13,5.21.81,3.88,2.19,3.68c1.16-.16,7.19-1.4,7.19-1.4s15.6-3.3,16.15-2.79-7.26,5.23-8.38,5.53-6,.22-7.14.77a2.53,2.53,0,0,0-.09,4.5,26.67,26.67,0,0,0,6.64,2.77,2.87,2.87,0,0,0-.68,3.29c1,1.78,1.61,1.78,3,2.19s4.86-.58,6.23-1.48,24.5-9.61,26-10.61,6.31-6.35,8.34-7.91a57.83,57.83,0,0,1,5.46-3.49Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.59,417.21a6.38,6.38,0,0,1,1-.83,11.81,11.81,0,0,1,1.28-.85l.82-.5,1-.49a69.4,69.4,0,0,1,11-4.12,111.61,111.61,0,0,0,11.1-3.79l1-.42.85-.43c.53-.26,1-.49,1.35-.71a7.41,7.41,0,0,1,1.15-.62,7.43,7.43,0,0,1-1.06.77,13.63,13.63,0,0,1-1.32.78l-.85.46-1,.45a86.91,86.91,0,0,1-11.09,3.93,81.15,81.15,0,0,0-11,4l-1,.46-.83.46a14.17,14.17,0,0,0-1.31.78A7.39,7.39,0,0,1,478.59,417.21Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.3,416.11a13,13,0,0,0,9.63-4.2,3.85,3.85,0,0,1-1,1.3,10.38,10.38,0,0,1-3.23,2.22,10.15,10.15,0,0,1-3.83.86A3.8,3.8,0,0,1,506.3,416.11Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.11,432.49a4.84,4.84,0,0,1,1-.32c.66-.17,1.61-.42,2.78-.75a80.41,80.41,0,0,0,17.47-7.25c1.06-.59,1.91-1.08,2.5-1.43a4.49,4.49,0,0,1,.94-.49,5.31,5.31,0,0,1-.85.64c-.56.39-1.39.92-2.43,1.55A66.74,66.74,0,0,1,496,431.72c-1.18.29-2.15.5-2.82.62A4.47,4.47,0,0,1,492.11,432.49Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.37 376.58 462.35 383.44 502.57 393.2 465.37 376.58",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.26,393.2a1.78,1.78,0,0,1-.43,0c-.28,0-.7,0-1.23-.09-1.06-.1-2.6-.29-4.48-.61a133.1,133.1,0,0,1-14.51-3.45c-5.6-1.52-10.77-2.57-14.44-3.64-1.84-.51-3.31-1-4.32-1.35a9.27,9.27,0,0,1-1.54-.63,11.34,11.34,0,0,1,1.6.44c1,.29,2.51.72,4.35,1.19,3.68,1,8.86,2,14.49,3.49s10.7,2.86,14.44,3.59c1.86.36,3.38.61,4.44.77A11.83,11.83,0,0,1,500.26,393.2Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cash-register--inject-124"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.61,
    y: 429.51,
    width: 56.21,
    height: 26.3,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.87,462.59s9.53-26.73,12.54-34.9a4.14,4.14,0,0,1,3.9-2.71H436.59v37.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.39,
    y: 424.98,
    width: 6.22,
    height: 34.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.84,425V406.92a3.9,3.9,0,0,1,3.29-3.85l109.19-17.18h26.05a4.92,4.92,0,0,1,4.92,4.92V425Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.76,
    y: 361.5,
    width: 10.63,
    height: 24.38,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.65,
    y: 343.01,
    width: 44.85,
    height: 18.49,
    rx: 2.11,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.83,403.14a1.34,1.34,0,0,1,.34-.09l1-.18,3.95-.67,14.53-2.37,48-7.62,41.9-6.53h0l19.2.09,5.27.06,1.38,0a2.15,2.15,0,0,1,.47,0l-.47,0-1.38,0-5.27.05-19.2.09h0l-41.88,6.64-48,7.46-14.56,2.21-4,.57-1,.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.92,361.5c0,.15-5.89.26-13.16.26s-13.16-.11-13.16-.26,5.89-.26,13.16-.26S424.92,361.36,424.92,361.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.15,
    y: 345.53,
    width: 38.43,
    height: 13.03,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.29,349.33l-.51,2.54c.91.27,1.85.57,1.85,1.62,0,1.25-1.06,2-2.57,2l-.22,1.09h-.46l.21-1.1a3.36,3.36,0,0,1-2.1-.84l.34-.55a3,3,0,0,0,1.89.79l.49-2.51c-.86-.27-1.74-.59-1.74-1.65,0-1.21,1-1.94,2.48-2l.21-1.08h.47l-.22,1.09a3.51,3.51,0,0,1,1.79.56l-.29.57A3.06,3.06,0,0,0,426.29,349.33Zm-.94,2.41.47-2.41c-1,.08-1.66.57-1.66,1.33C424.16,351.27,424.69,351.53,425.35,351.74Zm.31.76-.48,2.39c1.05-.05,1.76-.51,1.76-1.3C426.94,353,426.35,352.71,425.66,352.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.83,349.33l-.5,2.54c.9.27,1.84.57,1.84,1.62,0,1.25-1.06,2-2.57,2l-.22,1.09h-.46l.22-1.1a3.36,3.36,0,0,1-2.11-.84l.35-.55a3,3,0,0,0,1.88.79l.5-2.51c-.87-.27-1.75-.59-1.75-1.65,0-1.21,1-1.94,2.48-2l.22-1.08h.46l-.21,1.09a3.58,3.58,0,0,1,1.79.56l-.3.57A3.06,3.06,0,0,0,419.83,349.33Zm-.94,2.41.48-2.41c-1,.08-1.67.57-1.67,1.33C417.7,351.27,418.23,351.53,418.89,351.74Zm.31.76-.47,2.39c1-.05,1.75-.51,1.75-1.3C420.48,353,419.89,352.71,419.2,352.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.38,349.33l-.51,2.54c.91.27,1.85.57,1.85,1.62,0,1.25-1.07,2-2.57,2l-.22,1.09h-.47l.22-1.1a3.36,3.36,0,0,1-2.1-.84l.34-.55a3,3,0,0,0,1.89.79l.49-2.51c-.87-.27-1.74-.59-1.74-1.65,0-1.21,1-1.94,2.47-2l.22-1.08h.47l-.22,1.09a3.54,3.54,0,0,1,1.79.56l-.3.57A3,3,0,0,0,413.38,349.33Zm-.95,2.41.48-2.41c-1,.08-1.67.57-1.67,1.33C411.24,351.27,411.78,351.53,412.43,351.74Zm.32.76-.48,2.39c1.05-.05,1.75-.51,1.75-1.3C414,353,413.43,352.71,412.75,352.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.9,426.39c-.14,0-.26-8.93-.26-19.95s.12-19.95.26-19.95.26,8.93.26,19.95S398,426.39,397.9,426.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.27,429.51c0,.15-10.91.26-24.36.26s-24.36-.11-24.36-.26,10.91-.26,24.36-.26S281.27,429.37,281.27,429.51Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Counter--inject-124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.4,462.59c0,.15-148.33.26-331.26.26s-331.29-.11-331.29-.26,148.29-.26,331.29-.26S715.4,462.45,715.4,462.59Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.52,197,251,178.5a49.59,49.59,0,1,1,11.88,13.22l0,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.52,197l22.38-5.4-.07.2,0,0-.6-.78.78.6a51.09,51.09,0,0,0,10.16,6,49.44,49.44,0,0,0,13.5,3.8,44.18,44.18,0,0,0,7.78.37c1.33-.08,2.7-.12,4.07-.24l4.15-.64a49.56,49.56,0,0,0,30.62-19.74,48.84,48.84,0,0,0,8.26-18.94,50.11,50.11,0,0,0-.59-21.8,48.34,48.34,0,0,0-10.51-20.14l-2-2.2c-.65-.74-1.44-1.35-2.15-2s-1.42-1.37-2.22-1.94l-2.35-1.75a18.7,18.7,0,0,0-2.44-1.61l-2.48-1.51-2.6-1.27a22.88,22.88,0,0,0-2.63-1.17,50,50,0,0,0-22-3.39,48.43,48.43,0,0,0-20.17,5.94A49.94,49.94,0,0,0,246.08,138a53.61,53.61,0,0,0-2.18,16,49.34,49.34,0,0,0,2.35,13.82,50.41,50.41,0,0,0,4.89,10.62l0,.06,0,.07C244.33,190.4,241,196.25,240.52,197l10.4-18.58v.13a50.33,50.33,0,0,1-5-10.66,49.38,49.38,0,0,1-2.42-13.9,53.52,53.52,0,0,1,2.16-16.11A50.23,50.23,0,0,1,269.2,109a48.82,48.82,0,0,1,20.37-6,50.62,50.62,0,0,1,22.19,3.41,26.08,26.08,0,0,1,2.65,1.18l2.63,1.28,2.51,1.53A20.87,20.87,0,0,1,322,112l2.37,1.78a27.94,27.94,0,0,1,2.25,2c.72.68,1.51,1.3,2.18,2l2,2.22a48.94,48.94,0,0,1,10.61,20.36,50.49,50.49,0,0,1,.58,22,49.22,49.22,0,0,1-8.36,19.12,50,50,0,0,1-30.93,19.87l-4.19.63c-1.38.12-2.76.15-4.1.23a44.82,44.82,0,0,1-7.84-.4A49.82,49.82,0,0,1,273,198a50.91,50.91,0,0,1-10.19-6.14l.19-.18v0l.12.17-.19,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.69 153.28 281.7 148.27 291.36 156.86 310.33 138.61 314.98 143.62 290.65 166.52 276.69 153.28",
    style: {
      fill: "#F2A413"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterInteraction);
export default __webpack_public_path__ + "static/media/counter-interaction.ffad5603f3448b91d88f729e8eaf34de.svg";
export { ForwardRef as ReactComponent };